module.exports = __webpack_public_path__ + "img/mind_skeleton_11.8e3f2050.png";